import { ProductDetailAttributeInterface } from "../../interfaces/apiV2/product/ProductDetailInterface";

export interface ProductSpecificationEntry {
    key: string;
    label: string;
    dimensionsValue?: string;
    attribute?: ProductDetailAttributeInterface;
}

interface BuildEntriesParams {
    dimensions?: string | null;
    dimensionsLabel: string;
    attributes: ProductDetailAttributeInterface[];
}

export const buildProductSpecificationEntries = ({
    dimensions,
    dimensionsLabel,
    attributes,
}: BuildEntriesParams): ProductSpecificationEntry[] => {
    const entries: ProductSpecificationEntry[] = [];

    attributes.forEach((attribute) => {
        entries.push({
            key: attribute.code,
            label: attribute.label ?? "",
            attribute,
        });
    });

    if (dimensions) {
        entries.push({
            key: "dimensions",
            label: dimensionsLabel,
            dimensionsValue: dimensions,
        });
    }

    return entries;
};
